var palabras = document.getElementsByClassName('palabra-licoEs');
var wordArray = [];
var currentWord = 0;

palabras[currentWord].style.opacity = 1;
for (var i = 0; i < palabras.length; i++) {
  splitLetters(palabras[i]);
}

function cambiarPalabra() {
  var cw = wordArray[currentWord];
  var nw = currentWord == palabras.length-1 ? wordArray[0] : wordArray[currentWord+1];
  for (var i = 0; i < cw.length; i++) {
    animateLetterOut(cw, i);
  }
  
  for (var i = 0; i < nw.length; i++) {
    nw[i].className = 'letra-licoEs behind';
    nw[0].parentElement.style.opacity = 1;
    animateLetterIn(nw, i);
  }
  
  currentWord = (currentWord == wordArray.length-1) ? 0 : currentWord+1;
}

function animateLetterOut(cw, i) {
  setTimeout(function() {
		cw[i].className = 'letra-licoEs out';
  }, i*80);
}

function animateLetterIn(nw, i) {
  setTimeout(function() {
		nw[i].className = 'letra-licoEs in';
  }, 340+(i*80));
}

function splitLetters(word) {
  var content = word.innerHTML;
  word.innerHTML = '';
  var letters = [];
  for (var i = 0; i < content.length; i++) {
    var letter = document.createElement('span');
    letter.className = 'letra-licoEs';
    letter.innerHTML = content.charAt(i);
    word.appendChild(letter);
    letters.push(letter);
  }
  
  wordArray.push(letters);
}

cambiarPalabra();
setInterval(cambiarPalabra, 4000);